<template>
  <div class="block-steps" @contextmenu="openStepsContextMenu" @click="closeContextMenus">
    <context-menu ref="stepsContextMenu">
      <context-menu-option
        :disabled="!$store.state.flowCopiedElement"
        @click="pasteStep()"
      >{{ $t('btn.paste') }}</context-menu-option>
      <context-menu-option @click="closeStepsContextMenu">{{ $t('btn.close') }}</context-menu-option>
    </context-menu>

    <context-menu ref="singleStepContextMenu">
      <context-menu-option @click="copyStep">{{ $t('btn.copy') }}</context-menu-option>
      <context-menu-option
        :disabled="!$store.state.flowCopiedElement"
        @click="pasteStep(-1)"
      >{{ $t('btn.pasteBefore') }}</context-menu-option>
      <context-menu-option
        :disabled="!$store.state.flowCopiedElement"
        @click="pasteStep(1)"
      >{{ $t('btn.pasteAfter') }}</context-menu-option>
      <context-menu-option @click="closeSingleStepMenu">{{ $t('btn.close') }}</context-menu-option>
    </context-menu>

    <load-screen :startingText="$t('view.flow.editor.runningHooks')" ref="loader"></load-screen>
    <steps-validator @check="markProblems" :steps="steps" :blockUuid="blockUuid"></steps-validator>
    <flow-elements @add="createStep" ref="flowElements"></flow-elements>
    <steps-core
      ref="stepsCore"
      v-model="steps"
      @del="deleteStep"
      @singleStepMenu="openSingleStepMenu"
      :blockId="blockId"
    ></steps-core>
  </div>
</template>
<script>
export default {
  props: ['blockId', 'blockUuid'],
  data() {
    return {
      steps: [],
      groupedBlocks: {},
      singleStepMenuElementIndex: null,
      contextMenuIgnoredElements: ['textarea', 'text', 'pre', 'span']
    }
  },
  methods: {
    load(s, loc) {
      this.steps = this.prepareData(s)
    },

    _prepareDataCore(step) {
      step.uuid = this.uid()
      this.$set(step, 'errors', [])
      if (step.action === 'message') {
        step.editedText = ''
        if (!step.message.buttons) this.$set(step.message, 'buttons', [])
        for (let btn of step.message.buttons) this.$set(btn, 'uuid', this.uid())
      } else if (step.action === 'qr') {
        for (let reply of step.replies) this.$set(reply, 'uuid', this.uid())
      } else if (step.action === 'carousel') {
        for (let card of step.cards) {
          this.$set(card, 'uuid', this.uid())
          for (let btn of card.buttons) {
            this.$set(btn, 'uuid', this.uid())
          }
        }
      } else if (step.action === 'if') {
        for (const s of step.steps) {
          this._prepareDataCore(s)
        }

        for (const s of step.elseSteps) {
          this._prepareDataCore(s)
        }
      } else if (step.action === 'switch') {
        for (const s of step.defaultSteps) {
          this._prepareDataCore(s)
        }

        for (const c of step.cases) {
          for (const cs of c.steps) {
            this._prepareDataCore(cs)
          }
        }
      }
    },

    prepareData(steps) {
      for (let step of steps) this._prepareDataCore(step)
      return steps
    },

    async runHooks(hookName) {
      try {
        this.$refs.loader.show(40000)
        await this.$refs.stepsCore.runHooks(hookName)
        this.$refs.loader.hide()
      } catch (e) {
        this.$refs.loader.hide()
        throw e
      }
    },

    createStep(data) {
      const [prepared] = this.prepareData([data])
      this.$set(this.steps, this.steps.length, prepared)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    deleteStep(uuid) {
      for (let i in this.steps) {
        if (this.steps[i].uuid !== uuid) continue
        this.steps.splice(i, 1)
        this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
        this.$store.commit('SET_EDITED', true)
        break
      }
    },

    markProblemsCore(problems, i, recursiveCase = false) {
      // ifCase means that as i step from if blocks steps is passed
      if (!recursiveCase) {
        // Problem jest przy tym przypisaniu - switch block ma steps wewnątrz cases
        this.$set(this.steps[i], 'errors', problems[this.steps[i].uuid])
        if (this.steps[i].action === 'if') {
          for (const s of this.steps[i].steps) {
            this.markProblemsCore(problems, s, true)
          }

          for (const s of this.steps[i].elseSteps) {
            this.markProblemsCore(problems, s, true)
          }
        } else if (this.steps[i].action === 'switch') {
          for (const c of this.steps[i].cases) {
            for (const s of c.steps) {
              this.markProblemsCore(problems, s, true)
            }
          }

          for (const s of this.steps[i].defaultSteps) {
            this.markProblemsCore(problems, s, true)
          }
        } else if (this.steps[i].action === 'random') {
          for (const b of this.steps[i].blocks) {
            this.markProblemsCore(problems, b, true)
          }
        }
      } else {
        i.errors = problems[i.uuid]
        if (i.action === 'if') {
          for (const s of i.steps) {
            this.markProblemsCore(problems, s, true)
          }

          for (const s of i.elseSteps) {
            this.markProblemsCore(problems, s, true)
          }

        } else if (i.action === 'switch') {
          for (const c of i.cases) {
            for (const s of c.steps) {
              this.markProblemsCore(problems, s, true)
            }
          }

          for (const s of i.defaultSteps) {
            this.markProblemsCore(problems, s, true)
          }
        } else if (i.action === 'random') {
          for (const s of i.blocks) {
            this.markProblemsCore(problems, s, true)
          }
        }
      }
    },

    markProblems(problems) {
      this.$emit('change', this.steps, this.blockId) // Utilize watcher defined in validator to emit change event
      for (let i in this.steps) {
        this.markProblemsCore(problems, i)
      }
      this.$forceUpdate()
    },

    loadElementsModule() {
      this.$refs.flowElements.populateRepliesLocales()
    },

    removeStepIdentifiers(obj) {
      for (const prop in obj) {
        if (['uuid', 'uid'].indexOf(prop) !== -1) delete obj[prop]
        else if (typeof obj[prop] === 'object') this.removeStepIdentifiers(obj[prop])
      }
    },

    openStepsContextMenu(e) {
      const path = e.path || (e.composedPath && e.composedPath())
      for (const el of path) {
        if (el.classList && el.classList.contains('if-block')) return
      }
      if (this.contextMenuIgnoredElements.indexOf(e.target.tagName.toLowerCase()) !== -1 || e.target.offsetParent.classList.contains('ProseMirror')) return
      this.closeSingleStepMenu()
      this.$refs.stepsContextMenu.open(e)
    },

    openSingleStepMenu(e) {
      const path = e.path || (e.composedPath && e.composedPath())
      for (const el of path) {
        if (el.classList && el.classList.contains('if-block')) return
      }
      if (this.contextMenuIgnoredElements.indexOf(e.target.tagName.toLowerCase()) !== -1 || e.target.offsetParent.classList.contains('ProseMirror')) return
      this.singleStepMenuElementIndex = parseInt(path.find(el => el.classList.contains('block-steps__row')).dataset.index)
      this.$refs.stepsContextMenu.close()
      this.$refs.singleStepContextMenu.open(e)
    },

    closeStepsContextMenu() {
      this.$refs.stepsContextMenu.close()
    },

    closeSingleStepMenu() {
      this.$refs.singleStepContextMenu.close()
    },

    closeContextMenus() {
      this.$refs.singleStepContextMenu.close()
      this.$refs.stepsContextMenu.close()
    },

    copyStep(e) {
      const deepCpy = JSON.parse(JSON.stringify(this.steps[this.singleStepMenuElementIndex]))
      this.removeStepIdentifiers(deepCpy)
      this.$store.commit('COPY_FLOW_ELEMENT', JSON.stringify(deepCpy))
    },

    pasteStep(index) {
      const element = JSON.parse(this.$store.state.flowCopiedElement)
      const [prepared] = this.prepareData([element])
      if (!index) this.steps.push(prepared)
      else {
        let targetIndex = this.singleStepMenuElementIndex + index
        if (index === -1) targetIndex = this.singleStepMenuElementIndex
        if (targetIndex < 0) targetIndex = 0
        this.steps.splice(targetIndex, 0, prepared)
      }
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.block-steps {
  padding: 0 10px;
}
</style>
